import React, {useEffect, useState,useRef} from "react";
import PopComponent from "../../../commons/components/Popup/PopupComponent";
import Slider from "../../../commons/components/Slider";
import Button from "../../../commons/components/Button";
import PhotoSelector from "../../../commons/components/Forms/PhotoSelector";

import {sliceIntoChunks} from './../../../utils/helpers';
import API, {ROUTES} from "../../../commons/api/api";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import SwiperChildren from "../../../commons/components/SwiperChildren/SwiperChildren";


const InterestedContent = ({
    show,
    submitInterestedContent,
    characterModels,
    idCharacterActive = [],
    setPopupInterestedContent
}) => {


    const swiperRef = useRef();

    const [idCharacters, setIdCharacters] =  useState([]);

    const getIdCharacter = (ids) => {
        console.log(ids, 'getIdCharacter111');
        setIdCharacters(ids);
    }

    const submitFavoriteChildren = () => {
        submitInterestedContent(idCharacters)
    }

    const onSlideChange = () => {
        swiperRef.current.scrollTo(0, 0);
    }

    const handleClose = () => {
        setPopupInterestedContent(false)
    }

    return (
        <PopComponent
            id={"MD5"}
            show={show}
            handleClose={handleClose}
            // scrollable={true}
            style={{ backgroundColor: "#fff" }}
            bodyStyle={{ maxHeight: "90vh", padding : '10px' }}
            title={"맞춤정보 선택"}
            // headingStyle={{marginTop : '0px'}}
        >

            <div className={'row p-0 m-0 mb-3'}>
              <div className={'col-12 text-center'}>
                  <p className={'m-0 p-0 modal-children-modal-title'}>우리 아이가 좋아하는</p>
                  <p className={'m-0 p-0 modal-children-modal-title'}> 캐릭터를 모두 선택해주세요!</p>
              </div>
            </div>

            <div className={'box-children'} ref={swiperRef}>

                <SwiperChildren
                    characterModels={characterModels}
                    getIdCharacter={getIdCharacter}
                    onSlideChange={onSlideChange}
                    idCharacterActive={idCharacterActive}
                    show={show}
                />
            </div>

            <div className={'row mt-3 m-0 p-0 button-swiper-children'} >
                <div className={'col-12 m-0 p-0'}>
                    <button
                        type="button"
                        className="btn btn-block btn-primary btn-img"
                        onClick={submitFavoriteChildren}
                    >
                        스포키즈 시작하기
                    </button>
                </div>
            </div>

        </PopComponent>
    )
}

export default InterestedContent;
